<template lang="pug">
  file-loader(
    accept=".mp4"
    @onFileLoad="onFileLoad"
    @onDragOver="fileDragOver = $event"
  )
    slot(:fileDragOver="fileDragOver")
</template>

<script>
export default {
  components: {
    fileLoader: () => import('@/components/global/FileLoader.vue')
  },
  data: () => ({
    fileDragOver: false,
  }),
  methods: {
    onFileLoad(file) {
      if (/\.mp4$/.test(file.name.toLowerCase())) {
        this.$emit('on-file-load', file)
      } else {
        this.$notify({text: 'You could only upload *.mp4 files', type: 'error'})
      }
    },
  }
}
</script>
